export const stylesInJs = {
  header: {
    paddingInline: 15,
  },
}
